// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__acNMS","topBottomGutter":"Layout_topBottomGutter__3i_tA"};